import type { Profile } from 'api/api.types'

export const getFullName = (user: Pick<Profile, 'firstName' | 'lastName'> | null | undefined): string => {
  if (!user) {
    return ''
  }
  return [user.firstName, user.lastName].filter(Boolean).join(' ')
}
